import { REMINDER_STATUSES } from "constants/reminders";
import { REMINDER_LOG_STATUSES } from "constants/reminderLogs";

export const STATUSES_FOR_COLORS = {
  ...REMINDER_STATUSES,
  ...REMINDER_LOG_STATUSES,
  DEFAULT: 'DEFAULT',
};

export const SUCCESS_CLASSNAMES = 'bg-green-400/10 text-green-400 ring-green-400/20';
export const FAILED_CLASSNAMES = 'bg-red-400/10 text-red-400 ring-red-400/20';
export const NEUTRAL_CLASSNAMES = 'bg-gray-400/10 text-gray-400 ring-gray-400/20';

export const COLOR_MAP_BY_STATUS = {
  [STATUSES_FOR_COLORS.DEFAULT]: NEUTRAL_CLASSNAMES,
  [STATUSES_FOR_COLORS.ACTIVE]: SUCCESS_CLASSNAMES,
  [STATUSES_FOR_COLORS.PAUSED]: 'bg-yellow-400/10 text-yellow-500 ring-yellow-400/20',
  [STATUSES_FOR_COLORS.COMPLETED]: NEUTRAL_CLASSNAMES,
  [STATUSES_FOR_COLORS.DELETED]: NEUTRAL_CLASSNAMES,
  [STATUSES_FOR_COLORS.FAILED]: FAILED_CLASSNAMES,
  [STATUSES_FOR_COLORS.SUCCESS]: SUCCESS_CLASSNAMES,
  [STATUSES_FOR_COLORS.EMAIL_FAILED]: FAILED_CLASSNAMES,
  [STATUSES_FOR_COLORS.NOTIFICATION_FAILED]: FAILED_CLASSNAMES,
  [STATUSES_FOR_COLORS.WORKER_FAILED]: FAILED_CLASSNAMES,
  [STATUSES_FOR_COLORS.SKIPPED]: NEUTRAL_CLASSNAMES,
};
